<template>
  <div class="router-card">
    <router-link
      :to="path"
      :class="{ 'router-link-exact-active': routePath.startsWith(path) }"
      >{{ name }}</router-link
    >
  </div>
</template>
<script setup lang="ts">
import { useRoute } from "vue-router";
import { defineProps, computed } from "vue";
defineProps(["path", "name"]);
const route = useRoute();
const routePath = computed(() => route.path);
</script>
<style lang="less" scoped>
.router-card {
  font-size: 12px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

a {
  font-weight: bold;
  color: #2c3e50;
}
a.router-link-exact-active {
  font-weight: 400;
  color: #42b983;
  text-decoration: none;
}
</style>
